import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { IError, IFetchPayload } from "../../../interfaces/base";
import { IFetchVodsState } from "../../../interfaces/store/vods-interface";
import { CARDS_PAGE_SIZE } from "../../../common/config";

const initialState: IFetchVodsState = {
  vods: [],
  loading: false,
  error: null,
  requestState: "prepare",
  operation: null,
  metadata: {
    total: 0,
    page: 0,
  },
  tableState: {
    search: "",
    sort: {
      sortBy: "updatedAt",
      sortOrder: -1,
    },
    pagination: {
      page: 0,
      limit: CARDS_PAGE_SIZE,
      skip: 0,
    },
  },
};

const _fetchVodsStart = (
  state: IFetchVodsState,
  { payload }: PayloadAction<IFetchPayload>
) => {
  state.loading = true;
  state.error = null;
  state.requestState = "start";
  state.operation = "read";
  state.tableState.search = payload.search;
  state.tableState.sort = payload.sort;
  state.tableState.pagination = payload.pagination;
};

const _fetchVodsSuccess = (
  state: IFetchVodsState,
  { payload }: PayloadAction<any>
) => {
  state.vods = payload.data.data;
  state.metadata = payload.data.metadata;
  state.loading = false;
  state.error = null;
  state.requestState = "finish";
};

const _fetchVodsFailed = (
  state: IFetchVodsState,
  { payload }: PayloadAction<IError>
) => {
  state.loading = false;
  state.error = payload;
  state.requestState = "error";
};

const _resetVods = () => {
  return { ...initialState };
};

const VodsSlice = createSlice({
  name: "vods",
  initialState,
  reducers: {
    fetchVodsStart: _fetchVodsStart,
    fetchVodsSuccess: _fetchVodsSuccess,
    fetchVodsFailed: _fetchVodsFailed,
    resetVods: _resetVods,
  },
});

export const { fetchVodsStart, fetchVodsSuccess, fetchVodsFailed, resetVods } =
  VodsSlice.actions;
export default VodsSlice.reducer;
